import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ribbon',
    templateUrl: './ribbon.component.html',
    styleUrls: ['./ribbon.component.scss']
})
export class RibbonComponent implements OnInit {
    @Input() status: 'success' | 'success-neon' | 'secondary' | 'light' = 'success';
    @Input() position: 'bottom-right' | 'top-right' | 'top-left' = 'bottom-right'
    constructor() { }

    ngOnInit() {
    }

    protected color() {
        switch (this.status) {
            case 'success-neon':
                return "after:border-success-neon/50 before:border-success-neon/50"
            case 'success':
                return "after:border-success-neon/50 before:border-success/50"
            case 'secondary':
                return "after:border-secondary/50 before:secondary/50"
            case 'light':
                return "after:border-light/50 before:light/50"
            default:
                return "after:border-success-neon/50 before:border-success/50"
        }
    }

    protected spanColor() {
        switch (this.status) {
            case 'secondary':
                return "bg-secondary text-dark"
            case 'light':
                return "bg-light text-dark"
            case 'success':
            case 'success-neon':
                return "bg-success-neon text-dark"
            default:
                return "bg-success-neon text-dark"
        }
    }
}
